module.exports = __webpack_public_path__ + "img/VP-ECO13_Overview-Middle_1.d4d40fc7.jpg";